module.exports = __webpack_public_path__ + "static/no-one-knows-what-the-new-normal-is-ffe621f1b26abc4aa99bd8f36539abdc.png";